import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import * as api from "../../../services";
import AppContext from "../../../appContext";
import MutationMessage from "../../../Components/MutationMessage";
import RenameDialog from "../../../Components/RenameDialog";

export default function CounterButtonDialog({ open, handleClose }) {
  const { t } = useTranslation();
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const buttonMutation = useMutation(({ data }) => api.installCounter(data), {
    onSuccess: () => {
      handleClose();
    },
  });
  const renameFunction = (buttonText) => {
    const data = {
      clientId,
      buttonText,
      buttonLabel: buttonText,
      projectId,
      sessionId,
    };
    buttonMutation.mutate({ data });
  };
  return (
    <div>
      <MutationMessage
        mutation={buttonMutation}
        text={{
          loading: t("common.notifications.sendLoading"),
          /*           success: `Sent to ${alias}`, */
          success: t("common.notifications.sendSuccess"),
        }}
      />
      <RenameDialog
        open={open}
        setOpen={handleClose}
        renameFunction={renameFunction}
        input={""}
        dialogTitle={t("create.newCounterButton")}
        dialogContentText={`${t("create.counterButtonHelp")}:`}
        dialogActionCancel={t("common.actions.cancel")}
        dialogActionConfirm={t("interactions.buttonDialog.confirm")}
      />
    </div>
  );
}
